"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui";
import { useNavigateHome } from "@/hooks/use-navigate-home";
export default function AccessDenied() {
  const $ = _c(3);
  const goHome = useNavigateHome();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="text-center"><h1 className="text-h1 text-foreground">Access Denied</h1><p className="mt-2 text-foreground-secondary">You don't have permission to access this page.</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== goHome) {
    t1 = <div className="flex h-full flex-col items-center justify-center gap-4">{t0}<Button onClick={goHome} variant="secondary">Go to Home</Button></div>;
    $[1] = goHome;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}